import {inject, injectable} from 'inversify';

import type {
  DateObj,
  DateTimeObj,
  NaiveDateTimeObj,
} from '../../../../utils/datetime';
import type {Nullable} from '../../../../utils/utility-types';

import {datetimeObjToISOString} from '../../../../utils/datetime';
import {DateTimeModelFactory} from '../DateTime.factory';

@injectable()
export class DateTimeMapperJrpc {
  constructor(
    @inject(DateTimeModelFactory)
    private readonly dateTimeModelFactory: DateTimeModelFactory,
  ) {}

  mapDateToModel(data: DateObj) {
    return this.dateTimeModelFactory.createFromDateObject(data);
  }

  mapNullableToModel(data: Nullable<DateTimeObj>) {
    return data ? this.mapToModel(data) : null;
  }

  mapToIso(data: DateTimeObj) {
    return datetimeObjToISOString(data);
  }

  mapToModel(data: DateObj | DateTimeObj | NaiveDateTimeObj) {
    return this.dateTimeModelFactory.createFromDateTimeObject(data);
  }
}
